var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBetbookAnalysisIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "3 0 20 21",
    className: "icon betbook-analysis-icon",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "betbook-analysis-icon-sv_svg__a",
    width: "127%",
    height: "134.2%",
    x: "-13.5%",
    y: "-17.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FF8000",
    fillRule: "evenodd",
    filter: "url(#betbook-analysis-icon-sv_svg__a)",
    transform: "translate(-5 -14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 19a1 1 0 011 1v14a1 1 0 11-2 0V20a1 1 0 011-1zm5.333-4a1 1 0 011 1v18a1 1 0 01-2 0V16a1 1 0 011-1zm5.334 8a1 1 0 011 1v10a1 1 0 11-2 0V24a1 1 0 011-1zM27 27a1 1 0 011 1v6a1 1 0 11-2 0v-6a1 1 0 011-1z"
  }))));
}

export default SvgBetbookAnalysisIconSv;